import { useQuery } from '@tanstack/react-query'
import { Table, Tag, Tooltip, Typography } from 'antd'
import React, { useState } from 'react'
import { workspaceQueries } from '../../../../../Actions'
import {
  CREDIT_CHANGE_TYPE_LABEL,
  CREDIT_SOURCE_LABEL,
  CreditSource,
  TransactionReceipt,
  resolveCreditChangeType,
} from '../../../../../types/credit'

type Props = {
  workspaceId: number
}

export default function Receipts({ workspaceId }: Props) {
  const { data } = useQuery({ ...workspaceQueries.detail(workspaceId)._ctx.receipts })
  const [page, setPage] = useState(1)

  const sortedData: TransactionReceipt[] = [...((data ?? []) as TransactionReceipt[])].sort((a, b) =>
    b.createdAt.localeCompare(a.createdAt),
  )

  return (
    <div>
      <Table
        dataSource={sortedData}
        rowKey={(record) => record.receiptId}
        pagination={{
          total: sortedData.length,
          current: page,
          onChange: (newPage) => setPage(newPage),
          position: ['bottomCenter'],
        }}
        // scroll={{ y: 55 * 10 }}
        columns={[
          {
            title: 'createdAt',
            dataIndex: 'createdAt',
            key: 'createdAt',
          },
          {
            title: 'amount',
            dataIndex: 'amount',
            key: 'amount',
          },
          {
            title: '출처',
            dataIndex: 'creditSource',
            key: 'creditSource',
            // 사용 차감 행은 규약상 출처가 없고(소진 순서로 역산), 백필 이전 지급 행도 비어 있다
            render: (creditSource: CreditSource | null) =>
              creditSource ? <Tag>{CREDIT_SOURCE_LABEL[creditSource] ?? creditSource}</Tag> : '-',
          },
          {
            title: '변동 유형',
            key: 'changeType',
            // 원장에 유형 컬럼이 없어 부호 + 출처로 파생한다. 소멸·회수는 같은 모양이라 합쳐 표시한다
            render: (t, r: TransactionReceipt) => {
              const type = resolveCreditChangeType(r.amount, r.creditSource)
              const label = CREDIT_CHANGE_TYPE_LABEL[type]

              if (type === 'ISSUE_UNTAGGED') {
                return (
                  <Tooltip title="출처가 기록되지 않은 지급 행입니다. 백필 이전 데이터이거나 출처 태깅이 빠진 이상치(untaggedIssuance)입니다.">
                    <Typography.Text type="warning">{label}</Typography.Text>
                  </Tooltip>
                )
              }

              if (type === 'RECALL_OR_EXPIRE') {
                return (
                  <Tooltip title="회수와 소멸은 원장에서 같은 모양(음수 + 출처 있음)이라 구분할 수 없습니다. 예약 회수 건은 회수 예약 내역에서 확인하세요.">
                    <span>{label}</span>
                  </Tooltip>
                )
              }

              return label
            },
          },
          {
            title: 'memo',
            dataIndex: 'memo',
            key: 'memo',
            render: (t, r: any) => {
              switch (r.memo) {
                case 'welcome':
                  return '가입'
                case 'create movie':
                  return '영상 내보내기'
                case 'concat audios':
                  return '음성 내보내기'
                default:
                  return r.memo
              }
            },
          },
        ]}
      />
    </div>
  )
}
